import { type ActionCard } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';

// Names the larger card a card in a chat is part of, so a draft reads as a step of its to-do
export const ParentCardLine = observer(function ParentCardLine({
  card,
}: {
  card: ActionCard;
}) {
  // The parent syncs into the same MobX store, so React Compiler must not cache it
  'use no memo';
  if (!card.parentId) return null;
  const parent = card.store.get(card.parentId);
  if (!parent) return null;
  return (
    <span
      data-testid="card-parent-line"
      className="flex items-center gap-1 text-xs text-foreground-muted"
    >
      <Icons.link aria-hidden="true" className="size-3 shrink-0" />
      <span className="truncate">{`Part of #${parent.localId} ${parent.title}`}</span>
    </span>
  );
});
